"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6050,2280],{

/***/ 2280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ iframe_IFrame; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/base/iframe/IFrame.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var IFrame = function(props, ref) {
    if (props.children) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            title: "iframe",
            ref: ref,
            tabIndex: -1,
            src: String(props.children)
        }));
    } else {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", _objectSpread({
            title: "iframe",
            ref: ref,
            tabIndex: -1
        }, props)));
    }
};
/* harmony default export */ var iframe_IFrame = (/*#__PURE__*/react.forwardRef(IFrame));

;// CONCATENATED MODULE: ./components/base/iframe/index.tsx



/***/ }),

/***/ 6050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ asg_footer_AsgFooter; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./services/http/wap/query/mappers.ts
var mappers = __webpack_require__(9278);
// EXTERNAL MODULE: ./core/utils/index.ts + 2 modules
var utils = __webpack_require__(58);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./core/hooks/useWidthResize.ts
var useWidthResize = __webpack_require__(4546);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
;// CONCATENATED MODULE: ./components/widgets/asg-footer/constant.ts
var LOGOS_MAPPING = [
    {
        name: 'title',
        path: 'baslik',
        type: 'query'
    },
    {
        name: 'image',
        path: 'logo',
        type: 'query'
    },
    {
        name: 'imageWhite',
        path: 'beyazlogo',
        type: 'query'
    },
    {
        name: 'show',
        path: 'goster',
        type: 'query'
    },
    {
        name: 'anchor',
        path: 'webSiteLinki',
        type: 'query'
    }, 
];

// EXTERNAL MODULE: ./services/http/wap/query/index.ts + 1 modules
var query = __webpack_require__(6618);
// EXTERNAL MODULE: ./components/base/iframe/index.tsx + 1 modules
var iframe = __webpack_require__(2280);
// EXTERNAL MODULE: ./components/base/anchor/index.tsx
var base_anchor = __webpack_require__(5900);
// EXTERNAL MODULE: ./services/http/wap/page/index.ts + 4 modules
var page = __webpack_require__(7390);
// EXTERNAL MODULE: ./components/base/image/index.tsx + 1 modules
var base_image = __webpack_require__(5244);
// EXTERNAL MODULE: ./components/base/button/Button.tsx
var Button = __webpack_require__(5500);
;// CONCATENATED MODULE: ./components/widgets/asg-footer/AsgFooter.tsx
















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AsgFooter = function(props) {
    var ref6, ref1, ref2, ref3;
    var app = (0,contexts_app/* useApp */.qD)();
    var width = (0,useWidthResize/* useWidth */.z)();
    var router = (0,next_router.useRouter)();
    var template = app.theme.title;
    var ref4 = (0,react.useState)([]), firmsData = ref4[0], setFirmsData = ref4[1];
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var response, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return query/* default.run */.Z.run(app.environment, {
                                name: 'firmalar-get-veri-sorgusu-footer',
                                language: app.language
                            });
                        case 3:
                            response = _ctx.sent;
                            if (response) {
                                data = (0,mappers/* mapQuery */.w)(response.data, LOGOS_MAPPING);
                                setFirmsData(data);
                            }
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log('Error:', _ctx.t0);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    var handleLanguageSelection = function(language) {
        page/* default.findPath */.Z.findPath(app.environment, {
            path: app.page.path,
            language: language
        }).then(function(slug) {
            router.push(utils/* path.app */.E.app(app.environment, slug));
        }).catch(function() {
            var homepagePath = app.settings.homepage;
            if (homepagePath) {
                page/* default.findPath */.Z.findPath(app.environment, {
                    path: homepagePath,
                    language: language
                }).then(function(slug) {
                    router.push(utils/* path.app */.E.app(app.environment, slug));
                });
            }
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "".concat(props.isHome ? '' : 'not-home', " asg-footer ").concat(props.isReverse ? 'asg-footer-reverse' : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Container */.W2, {
            size: width < 768 ? 'extended' : template === 'Ana sayfa teması' ? 'extended' : 'wide',
            children: [
                (props.isHome || props.isContact) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Row */.X2, {
                    className: "footer-top-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
                            xl: {
                                size: 3
                            },
                            sm: {
                                size: 12
                            },
                            className: "address-bar",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "title",
                                    dangerouslySetInnerHTML: {
                                        __html: app.settings.translations['footerTitle']
                                    }
                                }),
                                props === null || props === void 0 ? void 0 : (ref6 = props.addresses) === null || ref6 === void 0 ? void 0 : ref6.map(function(item, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                                        className: "address",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: item.address
                                            }
                                        })
                                    }, index);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mail",
                                    children: props.mail
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            xl: {
                                size: 9
                            },
                            sm: {
                                size: 12
                            },
                            className: 'iframe-wrapper',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(iframe["default"], {
                                src: props.mapCode
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Row */.X2, {
                    className: "".concat(props.isHome || props.isContact ? '' : 'not-home', " footer-middle-wrapper"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
                            xl: {
                                size: 3
                            },
                            sm: {
                                size: 12
                            },
                            className: "footer-logo-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                    className: "footer-logo",
                                    href: app.settings.homepage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({}, ((ref1 = props.logo) === null || ref1 === void 0 ? void 0 : ref1.src) ? props.logo : app.theme.logo, {
                                        alt: app.page.title,
                                        height: 50
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "info",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: app.settings.translations['copyright']
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "language-wrapper",
                                    children: app.languages.map(function(language) {
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                onClick: function() {
                                                    return handleLanguageSelection(language.id);
                                                },
                                                children: language.name.substring(0, 2)
                                            })
                                        }, language.id));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            xl: {
                                size: 9
                            },
                            className: 'footer-menu-wrapper',
                            children: (ref2 = props.navigation) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, index) {
                                var ref, ref5;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: item.href === '#' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "title",
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: (ref = item.children) === null || ref === void 0 ? void 0 : ref.map(function(subItem, subIndex) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                                            href: subItem.href,
                                                            children: subItem.title
                                                        })
                                                    }, subIndex);
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                                href: item.href,
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: (ref5 = item.children) === null || ref5 === void 0 ? void 0 : ref5.map(function(subItem, subIndex) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                                            href: subItem.href,
                                                            children: subItem.title
                                                        })
                                                    }, subIndex);
                                                })
                                            })
                                        ]
                                    })
                                }, index));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        margin: '15px 0',
                        display: 'block'
                    },
                    dangerouslySetInnerHTML: {
                        __html: app.settings.translations['ASGIstirakler']
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                    className: "asg-footer-firms",
                    children: firmsData.map(function(item, index) {
                        return item.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            className: "item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, _objectSpread({}, item.anchor, {
                                children: props.isReverse ? /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({}, item.image, {
                                    height: 36,
                                    alt: item.title
                                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({}, item.imageWhite, {
                                    height: 36,
                                    alt: item.title
                                }))
                            }))
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Row */.X2, {
                    className: "footer-bottom-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
                            xl: {
                                size: 3
                            },
                            lg: {
                                size: 12
                            },
                            className: 'copy-wrapper',
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: app.settings.translations['ASGGrup']
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: app.settings.translations['DesignByBuKafa']
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            xl: {
                                size: 9
                            },
                            lg: {
                                size: 12
                            },
                            className: 'policy-wrapper',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: props === null || props === void 0 ? void 0 : (ref3 = props.policyNavigation) === null || ref3 === void 0 ? void 0 : ref3.map(function(menuItem, index) {
                                    var ref;
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: menuItem.className,
                                        children: ((ref = menuItem.href) === null || ref === void 0 ? void 0 : ref.indexOf('http')) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: menuItem.href,
                                            target: menuItem.target,
                                            dangerouslySetInnerHTML: {
                                                __html: menuItem.title
                                            },
                                            rel: "noreferrer"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                            href: menuItem.href,
                                            dangerouslySetInnerHTML: {
                                                __html: menuItem.title
                                            }
                                        })
                                    }, index));
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var asg_footer_AsgFooter = (AsgFooter);

;// CONCATENATED MODULE: ./components/widgets/asg-footer/index.tsx



/***/ })

}]);